<template>
  <v-app color="white">
    <v-container
      v-if="curriculum != null"
      class="mt-0 px-12 pt-10"
      style="background: white; min-height: 100%"
    >
      <v-row>
        <span class="mt-4"
          ><span
            >Сургалтын төлөвлөгөө:
            <!-- <strong v-if="curriculum.xprofession"
              >{{ curriculum.xprofession.name }}
            </strong>
            <span v-else> No Curriculum</span> -->
            <span v-if="userProfile.email == 'granditxxk@gmail.com'">{{
              curriculum.ref.path
            }}</span>
          </span>
          <span class="font-weight-bold">{{
            curriculum.name.toUpperCase()
          }}</span></span
        >
        <!-- <v-row justify="end">
          <v-btn
            color="secondary"
            @click="willSearch = !willSearch"
            class="mr-2"
          >
          Xичээл+
          </v-btn>
        </v-row> -->
      </v-row>
      <v-row class="mt-16" justify="space-start">
        <DashCard
          :dashObject="{ name: 'Нийт цаг', bgcolor: '#FFD54C', number: '111' }"
        >
        </DashCard>
        <DashCard
          :dashObject="{
            name: 'Ерөнхий суурь хичээл',
            bgcolor: '#ECECEC',
            number: '30',
          }"
        >
        </DashCard>
        <DashCard
          :dashObject="{
            name: 'Мэргэжлийн суурь',
            bgcolor: '#ECECEC',
            number: '40',
          }"
        >
        </DashCard>
        <DashCard
          :dashObject="{ name: 'Мэргэжлийн', bgcolor: '#ECECEC', number: '60' }"
        >
        </DashCard>
      </v-row>
      <v-row justify="end">
        <!-- <v-checkbox
          v-for="(check, i) in curriculumLessonTypes"
          v-bind:key="i"
          :label="check.name"
          class="mr-8"
          color="black"
        >
        </v-checkbox> -->
        <v-btn
            color="secondary"
            @click="willSearch = !willSearch"
            class="mr-2"
          >
          Xичээл+
          </v-btn>
      </v-row>
      <v-row justify="space-between">
        <v-col cols="12" :lg="colWidth" :md="colWidth">
          <v-row
            v-for="(curriculumLessonType, ltIndex) in curriculumLessonTypes"
            :key="'curriculumLessonType' + ltIndex"
          >
            <v-col cols="12">
              <h5 class="blue--text">
                {{ curriculumLessonType.name }} 
              </h5>
              <table
                v-if="curriculum.lessons && curriculum.lessons.length > 0"
                class="px-10 scoreBorderedTable my-4"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th class="scoreTableTodorhoilolt-hcell">No</th>
                    <th class="scoreTableTodorhoilolt-hcell">Нэр</th>
                    <th class="scoreTableTodorhoilolt-hcell">Англи нэр</th>
                    <th class="scoreTableTodorhoilolt-hcell">Монгол бичиг нэр</th>
                    <th class="scoreTableTodorhoilolt-hcell">Код</th>
                    <th class="scoreTableTodorhoilolt-hcell">Кредит</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(clesson, clIndex) in curriculum.lessons"
                    :key="'clesson' + clIndex"
                    @click="_removeLesson(clesson)"
                  >
                    <template
                      v-if="
                        clesson.curriculumLessonType &&
                        clesson.curriculumLessonType.code ==
                          curriculumLessonType.code
                      "
                    >
                      <td class="scoreTableTodorhoilolt-cell" style="width: 1%">
                        {{ clesson.index }}
                      </td>
                      <td class="scoreTableTodorhoilolt-cell text-left pl-2">
                        {{ clesson.lessonStandard.name }}  
                      </td>
                      <td class="scoreTableTodorhoilolt-cell text-left pl-2" :style="clesson.lessonStandard.nameEN?'':'background-color:red'">
                        {{ clesson.lessonStandard.nameEN }}
                      </td>
                      <td class="scoreTableTodorhoilolt-cell text-left pl-2" :style="clesson.lessonStandard.nameMX?'':'background-color:red'">
                        {{ clesson.lessonStandard.nameMX }}
                      </td>
                      <td
                        class="scoreTableTodorhoilolt-cell text-left pl-2"
                        style="width: 10%"
                      >
                        {{ clesson.lessonStandard.code }}
                      </td>
                      <td
                        class="scoreTableTodorhoilolt-cell"
                        style="width: 10%"
                      >
                        {{ clesson.lessonStandard.credit }}
                      </td>
                      <td> <v-btn text small><v-icon small>mdi-delete</v-icon></v-btn></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" :lg="colWidth2" :md="colWidth2" v-if="willSearch">
          <SearchLessonStandardTable
            v-if="xxschool && xunidepartments"
            :item="{
              name: 'Xичээлүүд',
              fbpath: 'lessons-standards',
              curriculumRefPath: curriculum.ref.path,
            }"
            :school="xxschool"
            :xunidepartments="xunidepartments"
            :semester="null"
            :addCurriculum="true"
            :curriculumLessonTypes="curriculumLessonTypes"
          ></SearchLessonStandardTable>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import MySetting from "@/views/MySetting";
import { mapState } from "vuex";
import DashCard from "./DashCard.vue";
const fb = require("../firebaseConfig.js");

export default {
  data: () => ({
    xunidepartments: null,
    xxschool: null,

    colWidth: 12,
    colWidth2: 0,
    willSearch: false,
    firstName: null,
    fbpath: null,
    curriculum: null,

    curriculumLessonTypes: [
      { name: "Ерөнхий суурь хичээл", code: 1 },
      { name: "Мэргэжлийн суурь хичээл", code: 2 },
      { name: "Мэргэшүүлэx хичээл", code: 3 },
      { name: "Дадлага", code: 4 },
      { name: "Дипломын ажил, төсөл, шалгалт", code: 5 },
    ],
  }),
  components: {
    LessonStandardTable: () => import("./infos/LessonStandardTable"),
    SearchLessonStandardTable: () =>
      import("@/views/lessons/SearchLessonStandardTable.vue"),
    DashCard,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  watch: {
    willSearch(val) {
      console.log(val);
      if (val) {
        this.colWidth = 6;
        this.colWidth2 = 4;
      } else {
        this.colWidth = 12;
        this.colWidth2 = 0;
      }
    },
  },
  created() {
    if (fb.yyschool)
      fb.db
        .doc(fb.yyschool)
        .get()
        .then((doc) => {
          let school = doc.data();
          school.ref = doc.ref;
          school.id = doc.id;
          this.xxschool = school;

          school.ref
            .collection("/xuni-departments")
            .orderBy("name", "asc")
            .onSnapshot((querySnapshot) => {
              this.xunidepartments = [];
              querySnapshot.forEach((doc) => {
                let item = doc.data();
                item.id = doc.id;
                item.ref = doc.ref;
                this.xunidepartments.push(item);
              });
            });
        });

    //   /schools/ZfSyFBWq7MQnmaCDLmAT/curriculums/Q0TFyq4klWONDnm6fYqn
    this.fbpath =
      fb.yyschool + "/curriculums/" + this.curriculumId + "/lessons";
    console.log(this.fbpath);

    fb.db
      .doc(fb.yyschool + "/curriculums/" + this.curriculumId)
      .onSnapshot((doc) => {
        let curriculum = doc.data();
        curriculum.id = doc.id;
        curriculum.ref = doc.ref;
        curriculum.lessons = null;
        curriculum.ref.collection("curriculums-lessons").onSnapshot((docs) => {
          curriculum.lessons = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let lesson = doc.data();
            lesson.id = doc.id;
            lesson.ref = doc.ref;
            lesson.index = counter;
            lesson.lessonStandard.ref.onSnapshot(doc=>{
              let x = doc.data()
              x.id = doc.id
              x.ref = doc.ref
              lesson.lessonStandard = x
            })
            curriculum.lessons.push(lesson);
          });
        });
        this.curriculum = curriculum;
      });
  },
  methods: {
    _removeLesson(clesson){
      var yes = confirm("Xичээлийг xөтөлбөрөөс устгаx уу?")
      if(yes){
        clesson.ref.delete()
      }
    }
  },
  props: {
    curriculumId: {
      type: String,
      required: true,
    },
  },
};
</script>
<style>
.scoreBorderedTable {
  border-collapse: collapse;
}
.scoreTableTodorhoilolt-hcell {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
  font-weight: bold !important;
}
.scoreTableTodorhoilolt-cell {
  border: 1px solid black;
  text-align: center;
  border-spacing: 0px !important;
  padding: 0px;
  cursor: pointer;
}
</style>